import { createRouter, createWebHistory } from 'vue-router';
// تعریف مسیرها
const routes = [
  {
    path: '/',
    name: 'Splash',
    component: () => import('@/pages/splash.vue'),
  },
  {
    path: '/booking',
    name: 'booking',
    component: () => import('@/pages/booking.vue'),
  },
  {
    path: '/:pathMatch(.*)*', // این مسیر هر روتی که وجود ندارد را می‌گیرد
    component: () => import('@/pages/splash.vue'),
  },
];

// ایجاد Router
const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
